@if (isFetching()) {
  <div class="loading">Chargement…</div>
}

@if (!isFetching()) {
  <div class="fiche-container animate-fade-in">

    <!-- Page header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 md:pt-8 px-2 md:px-4">
      <div class="justify-self-start">
        <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux communiqués</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">{{ pageTitle }}</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    @if (errorMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }
    @if (successMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-emerald-50 border border-emerald-100 text-sm text-emerald-700 flex items-center gap-3">
        <span class="material-icons text-base text-emerald-500">check_circle</span>
        {{ successMessage() }}
      </div>
    }

    <form (ngSubmit)="onSave()">
      <div class="fiche-content-area space-y-6">

        <!-- Informations -->
        <div class="fiche-section">
          <div class="fiche-section-title">Informations du communiqué</div>
          <div class="fiche-section-box">
            <div class="fiche-grid">

              <div class="fiche-field">
                <span class="fiche-label-fixed">Titre <span class="text-red-500">*</span></span>
                <input type="text"
                  [value]="formData().title_ln1"
                  (input)="updateField('title_ln1', $any($event.target).value)"
                  maxlength="255"
                  placeholder="Titre du communiqué"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Date <span class="text-red-500">*</span></span>
                <input type="date"
                  [value]="formData().publish_date"
                  (input)="updateField('publish_date', $any($event.target).value)"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">N° Référence</span>
                <input type="text"
                  [value]="formData().reference || ''"
                  (input)="updateField('reference', $any($event.target).value)"
                  maxlength="100"
                  placeholder="Ex: FRMTT/2024/001"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Tags</span>
                <app-tag-input module="COMMUNIQUE" [value]="formData().press_tags || ''" (valueChange)="updateField('press_tags', $event)"></app-tag-input>
              </div>

            </div>
          </div>
        </div>

        <!-- Document PDF -->
        <div class="fiche-section">
          <div class="fiche-section-title">Document officiel (PDF)</div>
          <div class="fiche-section-box flex items-center gap-6 p-5">

            <!-- Current file indicator -->
            @if (isEditMode && currentPdfUrl()) {
              <div class="flex-shrink-0 flex flex-col items-center gap-2">
                <div class="w-14 h-16 bg-white border border-stone-200 rounded-lg flex items-center justify-center shadow-sm">
                  <svg class="w-7 h-7 text-primary-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                  </svg>
                </div>
                <a [href]="currentPdfUrl()!" target="_blank" rel="noopener noreferrer"
                  class="text-xs text-primary-600 hover:underline">Voir le fichier</a>
              </div>
            }

            <div class="flex flex-col items-start gap-2 flex-1">
              @if (selectedPdfName()) {
                <div class="flex items-center gap-2 text-xs text-emerald-700 bg-emerald-50 px-3 py-2 rounded-lg border border-emerald-200 w-full">
                  <svg class="w-4 h-4 text-emerald-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span class="font-medium truncate flex-1">{{ selectedPdfName() }}</span>
                  <button type="button" (click)="removePdf()" class="text-stone-400 hover:text-stone-600">
                    <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              }
              <label class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium cursor-pointer hover:bg-primary-700 transition-colors">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                {{ selectedPdfName() ? 'Changer le fichier' : 'Uploader le document' }}
                <input type="file" class="hidden" accept=".pdf,application/pdf" (change)="onPdfSelected($event)" />
              </label>
              <p class="text-xs text-stone-500">PDF uniquement · Max 10 Mo</p>
            </div>

          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-3 pt-2">
          <button type="button" (click)="onCancel()" [disabled]="isLoading()"
            class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors text-sm font-medium">
            Annuler
          </button>
          <button type="submit" [disabled]="isLoading()"
            class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-semibold shadow-sm shadow-primary-600/10">
            @if (isLoading()) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            }
            {{ isLoading() ? 'Enregistrement…' : 'Enregistrer' }}
          </button>
        </div>

      </div>
    </form>
  </div>
}
